<template>
  <base-tabs-view
    :tabs="Tabs"
  />
</template>

<script>
import BaseTabsView from '@/components/shared/base/base-tabs-view'
import BaseTabsViewMixin from '@/mixins/base-tabs-view-mixin'

export default {
  name: 'Documents',
  components: {
    BaseTabsView
  },
  mixins: [
    BaseTabsViewMixin
  ],
  computed: {
    Tabs () {
      return [
        {
          component: 'documents-list',
          idComponent: this.constantMixin.menuItem.documents.general,
          name: this.TextMixin_GetTab(this.BaseTabsViewMixin_GetDetailsTab(), this.TextMixin_GetParameter('document'))
        }
        // {
        //   component: 'base-under-construction',
        //   disabled: !this.ContentMixin_Element,
        //   idComponent: this.constantMixin.menuItem.documents.general,
        //   name: this.TextMixin_GetTab(this.BaseTabsViewMixin_GetDetailsTab(), this.TextMixin_GetParameter('document'))
        // }
      ]
    }
  }
}
</script>
